<template>
  <div class="home">
    <img class="hero-img" src="@/assets/Home/images/BU_Photonics.jpg" alt="Boston University Photonics Building">
    <h2>CAADLab Mission Statement</h2>
    <div class="intro">
        <span v-html="missionStatement"/>
    </div>
    <h2>Research Focus</h2>
    <div class="focus reverse">
      <img class="focus-item-img" src="@/assets/Home/images/Azure_datacenter_edit.jpg" alt="Azure datacenter image">
      <div class="focus-item-text">
        <h3>Computer Systems</h3>
        <span v-html="focusCompSystem"/>
      </div>
    </div>
    <div class="focus">
      <img class="focus-item-img" src="@/assets/Home/images/Computer_Arch.jpg" alt="Programmable logic chips image">
      <div class="focus-item-text" >
        <h3>Computer Architecture</h3>
        <span v-html="focusCompArch"/>
      </div>
    </div>
    <div class="focus reverse">
      <img class="focus-item-img" src="@/assets/Home/images/Machine_Learning.png" alt="Machine Learning image">
      <div class="focus-item-text" >
        <h3>Machine Learning</h3>
        <span v-html="focusML"/>
      </div>
    </div>

    <h2>Support</h2>
      <div class="marquee">
        <div class="marquee-item"> 
          <a v-for="(corp,i) in [...support, ...support]" :key="`${corp.name}_${i}`" :href="corp.link">
            <img :src="getImg(corp.img)" :alt="corp.name">
          </a>
        </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Support            from '@/assets/Home/Support.json';
import Mission_Statement  from '@/assets/Home/Mission_Statement.txt';
import Focus_Comp_System  from '@/assets/Home/Focus_Computer_Systems.txt';
import Focus_Comp_Arch    from '@/assets/Home/Focus_Computer_Arch.txt';
import Focus_ML           from '@/assets/Home/Focus_Machine_Learning.txt';

export default {
  name: 'HomePage',
  components: {
  },
  data () {
    return {
      support: Support,
      focusCompSystem: Focus_Comp_System,
      focusCompArch: Focus_Comp_Arch,
      focusML: Focus_ML,
      missionStatement: Mission_Statement,
    }
  },
  methods: {
    getImg: function(imgname) {
      return require(`@/assets/Home/images/${imgname}`);
    },
  }
}
</script>

<style scoped>
.home {
  width: 100%;
  padding-bottom: 0.5rem;
}
.intro {
  padding: 0 1rem;
}
.hero-img{
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: 50% 60%;
}

.focus {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.focus.reverse{
  flex-direction: row-reverse;
}
.focus-item-text{
  flex-grow: 1;
}
.focus-item-img{
  max-height: 200px;
  width: 100%;
  object-fit: cover;
}

/* Attempting scrolling effect */
.marquee {
  margin-top: 0.5rem;
  height: 100px;
  overflow: hidden;
}

.marquee-item {
  width: max-content;
  height: 100%;
  margin: 0;
  animation: scroll-left 20s linear infinite;
}
.marquee-item:hover {
  animation-play-state: paused;
}
.marquee-item a{
  height: inherit;
}
.marquee-item img{
  padding: 0 1rem;
  height: inherit;
  max-width: 350px;
  object-fit: contain;
}

@keyframes scroll-left {
  0% {
      transform: translateX(0%);
  }
  100% {
      transform: translateX(-50%);
  }
}

/* Reactive section */
@media all and (min-width: 700px) {
  .hero-img{
    height: 460px;
  }

  .focus {
    flex-wrap: nowrap;
  }
  .focus-item-img{
    flex: 0 0 30%;
  }
}
</style>